export const animateButtonPress = (ref, className, duration = 150) => {
  return new Promise((resolve) => {
    if (!ref.current) return resolve();

    ref.current.classList.add(className);

    setTimeout(() => {
      if (ref.current && ref.current.classList.contains(className)) {
        ref.current.classList.remove(className);
      }

      setTimeout(() => {
        resolve();
      }, duration)

    }, duration);
  });
};
